import { combineReducers } from 'redux';
import { PayloadAction } from '../types/global';
import caregiverReducer, { CaregiverState } from './caregiver';
import contentReducer, { ContentState } from './content';
import globalReducer, { GlobalState } from './global';
import patientReducer, { PatientState } from './patient';
import searchReducer, { SearchState } from './search';
import securityReducer, { SecurityState } from './security';
import trainingReducer, { TrainingState } from './training';
import physicianReducer, { PhysicianState } from './physician';
import userReducer, { UserState } from './user';
import lookupReducer, { LookupState } from './lookup';
import dispenserReducer, { DispenserState } from './dispenser';
import transporterReducer, { TransporterState } from './transporter';
import orderReducer, { OrderState } from './order';
import demographicsCompareReducer, { DemographicsCompareState } from './demographics';
import certificationReducer, { CertificationState } from './certification';
import cardholderReducer, { CardholderState } from './cardholder';
import organizationReducer, { OrganizationState } from './organization';
import toolsReducer, { ToolsState } from './tools';
import mqaToggleReducer, { MqaToggleState } from './mqa_toggle';
import suspensionReducer, { SuspensionState } from './suspension';

interface RootReducerInterface {
  global: (state: GlobalState, action: PayloadAction<any>) => GlobalState,
  patient: (state: PatientState, action: PayloadAction<any>) => PatientState,
  cardholder: (state: CardholderState, action: PayloadAction<any>) => CardholderState,
  security: (state: SecurityState, action: PayloadAction<any>) => SecurityState,
  search: (state: SearchState, action: PayloadAction<any>) => SearchState,
  caregiver: (state: CaregiverState, action: PayloadAction<any>) => CaregiverState,
  content: (state: ContentState, action: PayloadAction<any>) => ContentState,
  training: (state: TrainingState, action: PayloadAction<any>) => TrainingState,
  transporter: (state: TransporterState, action: PayloadAction<any>) => TransporterState,
  physician: (state: PhysicianState, action: PayloadAction<any>) => PhysicianState,
  certification: (state: CertificationState, action: PayloadAction<any>) => CertificationState,
  dispenser: (state: DispenserState, action: PayloadAction<any>) => DispenserState,
  order: (state: OrderState, action: PayloadAction<any>) => OrderState,
  user: (state: UserState, action: PayloadAction<any>) => UserState,
  tools: (state: ToolsState, action: PayloadAction<any>) => ToolsState,
  lookup: (state: LookupState, action: PayloadAction<any>) => LookupState,
  demographics: (state: DemographicsCompareState, action: PayloadAction<any>) => DemographicsCompareState,
  organization: (state: OrganizationState, action: PayloadAction<any>) => OrganizationState,
  mqaToggle: (state: MqaToggleState, action: PayloadAction<any>) => MqaToggleState,
  suspension: (state: SuspensionState, action: PayloadAction<any>) => SuspensionState
}

export interface RootReducerState {
  global: GlobalState,
  patient: PatientState,
  cardholder: CardholderState,
  security: SecurityState,
  search: SearchState,
  caregiver: CaregiverState,
  content: ContentState,
  training: TrainingState,
  transporter: TransporterState,
  physician: PhysicianState,
  certification: CertificationState,
  dispenser: DispenserState,
  order: OrderState,
  user: UserState,
  tools: ToolsState,
  lookup: LookupState,
  demographics: DemographicsCompareState,
  organization: OrganizationState,
  mqaToggle: MqaToggleState,
  suspension: SuspensionState
}

const rootReducer: (state: RootReducerState, action: any) => RootReducerState = combineReducers({
  global: globalReducer,
  patient: patientReducer,
  cardholder: cardholderReducer,
  security: securityReducer,
  search: searchReducer,
  caregiver: caregiverReducer,
  content: contentReducer,
  training: trainingReducer,
  transporter: transporterReducer,
  physician: physicianReducer,
  certification: certificationReducer,
  dispenser: dispenserReducer,
  order: orderReducer,
  user: userReducer,
  tools: toolsReducer,
  lookup: lookupReducer,
  demographics: demographicsCompareReducer,
  organization: organizationReducer,
  mqaToggle: mqaToggleReducer,
  suspension: suspensionReducer
} as RootReducerInterface);

export default rootReducer;
